import { render, staticRenderFns } from "./PaymentsPlan.vue?vue&type=template&id=4cfc82e2&scoped=true&"
import script from "./PaymentsPlan.vue?vue&type=script&lang=js&"
export * from "./PaymentsPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfc82e2",
  null
  
)

export default component.exports